import { QR_ROUTES } from '../constants/qr';
import store from '../store';
import { useQrVisitorContext } from '../composables/qr/useQrVisitorContext';

const meta = {
    theme: 'payments',
    title: 'qr visitor',
};

// Disabled community/location keeps visitors on the home screen, even via a direct URL
const requireCallableEntrance = to => {
    if (store.getters['qr/canCallResidents']) return true;
    return { name: QR_ROUTES.HOME, params: { entranceId: to.params.entranceId }, replace: true };
};

const requireVerifiedLocation = to => {
    if (useQrVisitorContext().isVerifiedFor(to.params.entranceId)) return true;
    return { name: QR_ROUTES.LOCATION, params: { entranceId: to.params.entranceId }, replace: true };
};

const routes = [
    // Static path so a bare /qr is never captured by the Pass /:id route
    {
        name: QR_ROUTES.INVALID,
        path: '/qr',
        component: () => import('../views/qr/Shell'),
        meta,
    },
    {
        path: '/qr/:entranceId',
        component: () => import('../views/qr/Shell'),
        meta,
        children: [
            {
                name: QR_ROUTES.HOME,
                path: '',
                component: () => import('../views/qr/Home'),
            },
            {
                path: 'home',
                redirect: to => ({ name: QR_ROUTES.HOME, params: { entranceId: to.params.entranceId } }),
            },
            {
                name: QR_ROUTES.SEARCH,
                path: 'search',
                component: () => import('../views/qr/Directory'),
                beforeEnter(to) {
                    const unavailable = requireCallableEntrance(to);
                    return unavailable === true ? requireVerifiedLocation(to) : unavailable;
                },
            },
            {
                name: QR_ROUTES.LOCATION,
                path: 'location',
                component: () => import('../views/qr/Location'),
                beforeEnter: requireCallableEntrance,
            },
            {
                name: QR_ROUTES.CALL,
                path: 'call/:residentId',
                component: () => import('../views/qr/Call'),
                beforeEnter(to) {
                    const unverified = requireCallableEntrance(to);
                    if (unverified !== true) return unverified;
                    const locationUnverified = requireVerifiedLocation(to);
                    if (locationUnverified !== true) return locationUnverified;
                    const resident = store.getters['qr/selectedResident'];
                    if (!resident || String(resident.id) !== to.params.residentId) {
                        return { name: QR_ROUTES.SEARCH, params: { entranceId: to.params.entranceId }, replace: true };
                    }
                    return true;
                },
            },
        ],
    },
];

export default routes;
